// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"826":"478c7701","887":"ea50268b"}[chunkId] + ".chunk.css";
};